export const ACCOUNT_STATUSES = {
    notActivated: 'NOT_ACTIVATED',
    accepted: 'ACCEPTED'
};

export const MARITAL_STATUSES = ['MARRIED', 'SINGLE', 'DIVORCED', 'WIDOWER'];

export const GENDERS = ['MALE', 'FEMALE', 'OTHER'];
